import { LOCALES } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';
import client from '~/services/client';
import logger from '~/services/logger';
import wms from '~/services/wms';
import { booleanToNumber, downloadFile, extractFileName } from '~/utils/helpers';
import './style.scss';

type ServiceType = 'google-merchant' | 'facebook';

const Row = ({ title, type }: { title: string; type: ServiceType }) => {
  const handleDownload = (lang: LOCALES) => () => {
    downloadLanguage(type, lang);
  };

  return (
    <tr>
      <td className="family-medium text-size-18">{localeStore.t(title)}</td>
      <td>
        <a className="family-medium text-size-18 color-mainblue cursor-pointer" onClick={handleDownload(LOCALES.EN)}>
          {localeStore.t('download_english')}
        </a>
      </td>
      <td>
        <a className="family-medium text-size-18 color-mainblue cursor-pointer" onClick={handleDownload(LOCALES.AR)}>
          {localeStore.t('download_arabic')}
        </a>
      </td>
    </tr>
  );
};

const ProductFeed = () => {
  return (
    <table className="product-feed-table">
      <tbody>
        <Row title="google_merchant" type="google-merchant" />
        <Row title="facebook" type="facebook" />
      </tbody>
    </table>
  );
};

const downloadLanguage = async (type: ServiceType, language: LOCALES) => {
  try {
    const { data, headers } = await client.get(
      `v3/product-feed/${type}`,
      {
        params: { file: booleanToNumber(!window.IS_MOBILE), language },
        responseType: window.IS_MOBILE ? 'text' : 'blob',
        headers: { 'Accept-Language': language },
      },
      true
    );

    if (window.IS_MOBILE) {
      wms.downloadFile(data);
    } else {
      downloadFile(data, extractFileName(headers));
    }
  } catch (error: any) {
    logger.error({ error, place: 'ProductFeed downloadLanguage' });
  }
};

export default ProductFeed;
